import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root' // 全局单例
})
export class SharedDataService {
  private globalData = new BehaviorSubject<any>(this.getInitialData());

  currentData = this.globalData.asObservable();

  /**
   * 是否静默"无权限"(rtnCode 10010) 的 NO_PERMISSION 弹窗提示。
   * 仅由特定页面（如首页）在其存活期间临时置为 true，不持久化。
   */
  silentNoPermission = false;

  private getInitialData() {
    // 从 localStorage 读取或返回默认值
    const savedData = localStorage.getItem('is_dealerPortal');
    return savedData ? JSON.parse(savedData) : {
      isDealerPortal: true,
    };
  }

  updateData(newData: any) {
    // 合并新旧数据
    const updatedData = { ...this.globalData.value, ...newData };
    this.globalData.next(updatedData);
    localStorage.setItem('is_dealerPortal', JSON.stringify(updatedData));
  }
}
